import iMicRed from "../../assets/images/100-mic-red.svg";
import iRemove from "../../assets/images/100-remove-gray.svg";
import iRetry from "../../assets/images/100-retry-gray.svg";
import avatar from "../../assets/images/avatar2.png";
import groupAvatar from "../../assets/images/participants.svg";

const SingleParticipant = ({ state = "normall", isGroup = false }) => (
  <section className="single-user">
    <div className="align-items-center">
      <img alt="" src={isGroup ? groupAvatar : avatar} width={36} height={36} />
      <div className="m-l-6 fg-text-white flex-col">
        <span className=" B3-SemiBold">John Smith {isGroup && "(8)"}</span>
        {state === "add-success" && <span className="C2-Regular fg-text-green">Invited Now</span>}
        {state === "removed" && <span className="C2-Regular fg-text-red">Removed by you</span>}
        {state === "normall" && <span className="C2-Regular">Added by you</span>}
      </div>
    </div>
    {isGroup ? (
      <div className="flex">{state === "normall" && <img alt="" src={iRemove} width={36} height={36} className="flex pointer" />}</div>
    ) : (
      <div className="flex">
        {state === "add-success" && <img alt="" src={iRemove} width={36} height={36} className="flex pointer" />}
        {state === "removed" && (
          <>
            <img alt="" src={iRetry} width={36} height={36} className="flex pointer" id="tooltip-a1" />
            <div className="fg-tooltip top-right" id="tooltip-1">
              invite again
            </div>
          </>
        )}
        {state === "normall" && <img alt="" src={iMicRed} width={36} height={36} className="flex pointer" />}
        {state === "normall" && <img alt="" src={iRemove} width={36} height={36} className="flex pointer m-l-8" />}
      </div>
    )}
  </section>
);

export default SingleParticipant;
